import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const ExpertSpotlight = ({ expert }) => {
  return (
    <div className="bg-card border border-border rounded-lg p-5 hover:shadow-lg transition-smooth">
      <div className="flex items-start gap-4 mb-4">
        <div className="w-16 h-16 rounded-full overflow-hidden flex-shrink-0">
          <Image
            src={expert?.photo_url || 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e'}
            alt={expert?.name || 'Expert photo'}
            className="w-full h-full object-cover"
          />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="text-lg font-semibold text-foreground mb-1">
            {expert?.name}
          </h3>
          <p className="text-sm text-muted-foreground mb-2">
            {expert?.title}
          </p>
          {expert?.organization && (
            <p className="text-xs text-muted-foreground">
              {expert?.organization}
            </p>
          )}
        </div>
      </div>

      <p className="text-sm text-muted-foreground line-clamp-3 mb-4">
        {expert?.bio}
      </p>

      {expert?.expertise_areas?.length > 0 && (
        <div className="flex flex-wrap gap-2 mb-4">
          {expert?.expertise_areas?.slice(0, 3)?.map((area, index) => (
            <span
              key={index}
              className="px-2.5 py-1 bg-primary/10 text-primary text-xs font-medium rounded-full"
            >
              {area}
            </span>
          ))}
        </div>
      )}

      <div className="flex items-center gap-3">
        {expert?.linkedin_url && (
          <a
            href={expert?.linkedin_url}
            target="_blank"
            rel="noopener noreferrer"
            className="text-muted-foreground hover:text-primary transition-colors"
          >
            <Icon name="Linkedin" size={18} />
          </a>
        )}
        {expert?.twitter_url && (
          <a
            href={expert?.twitter_url}
            target="_blank"
            rel="noopener noreferrer"
            className="text-muted-foreground hover:text-primary transition-colors"
          >
            <Icon name="Twitter" size={18} />
          </a>
        )}
        {expert?.website_url && (
          <a
            href={expert?.website_url}
            target="_blank"
            rel="noopener noreferrer"
            className="text-muted-foreground hover:text-primary transition-colors"
          >
            <Icon name="Globe" size={18} />
          </a>
        )}
      </div>
    </div>
  );
};

export default ExpertSpotlight;